import React from 'react';
import { C } from '../constants';

const HomeIcon = ({ active }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill={active ? C.accentSoft : 'rgba(255,255,255,0.38)'}>
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
  </svg>
);

const MovieIcon = ({ active }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill={active ? C.accentSoft : 'rgba(255,255,255,0.38)'}>
    <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/>
  </svg>
);

const SeriesIcon = ({ active }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill={active ? C.accentSoft : 'rgba(255,255,255,0.38)'}>
    <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"/>
  </svg>
);

const BookmarkIcon = ({ active }) => (
  <svg width="21" height="21" viewBox="0 0 24 24" fill={active ? C.accentSoft : 'rgba(255,255,255,0.38)'}>
    <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"/>
  </svg>
);

const TABS = [
  { id: 'all',       label: 'Inicio',   Icon: HomeIcon },
  { id: 'movie',     label: 'Films',    Icon: MovieIcon },
  { id: 'series',    label: 'Series',   Icon: SeriesIcon },
  { id: 'watchlist', label: 'Mi Lista', Icon: BookmarkIcon },
];

export default function BottomNav({ filter, onFilter }) {
  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      zIndex: 300,
      background: 'rgba(8,4,2,0.97)',
      borderTop: '1px solid rgba(201,113,74,0.18)',
      backdropFilter: 'blur(24px)',
      WebkitBackdropFilter: 'blur(24px)',
      display: 'flex',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {TABS.map(({ id, label, Icon }) => {
        const active = filter === id;
        return (
          <button key={id} onClick={() => onFilter(id)} style={{
            flex: 1,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: '4px',
            padding: '10px 4px 8px',
            background: 'transparent', border: 'none', cursor: 'pointer',
            position: 'relative',
            WebkitTapHighlightColor: 'transparent',
          }}>
            {active && (
              <span style={{
                position: 'absolute', top: 0, left: '50%',
                transform: 'translateX(-50%)',
                width: '30px', height: '2px',
                background: `linear-gradient(90deg, ${C.accent}, ${C.accentSoft})`,
                borderRadius: '0 0 3px 3px',
              }} />
            )}
            <Icon active={active} />
            <span style={{
              fontSize: '10px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: active ? '600' : '400',
              color: active ? C.accentSoft : 'rgba(255,255,255,0.38)',
              letterSpacing: '0.2px',
              transition: 'color 0.15s',
            }}>
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
